import React from "react";
import AdminOrgChartView from "./AdminOrgChartView";
import { EXTRAS_ORGANIGRAMA } from "Shared/Routing/Application/Constants/PathsConstant";

const AdminExtrasOrgChartView = () => {
  return (
    <AdminOrgChartView
      fixedChartType="EXTRAS"
      adminTitle="Administrador de Extras"
      adminDescription="Gestiona la estructura de extras. Solo se permiten nodos raiz dentro de EXTRAS."
      allowNewStructure={false}
      allowStructureRenameDelete={false}
      allowBuilderPanel={false}
      allowChildCreation={true}
      allowEmployeeAssignment={false}
      allowReparenting={true}
      rootButtonLabel="Crear nodo de EXTRAS"
      autoCreateRootTitle="EXTRAS"
      rootDialogTitle="Nuevo Nodo de Extras"
      rootDialogDescription="Se creara un nodo de extras en nivel 0:"
      backToPath={EXTRAS_ORGANIGRAMA}
    />
  );
};

export default AdminExtrasOrgChartView;